module.exports = __webpack_public_path__ + "img/business111.3264496e.png";